import { render, staticRenderFns } from "./TournamentStatusBar.vue?vue&type=template&id=216915f3&scoped=true&"
import script from "./TournamentStatusBar.vue?vue&type=script&lang=js&"
export * from "./TournamentStatusBar.vue?vue&type=script&lang=js&"
import style0 from "./TournamentStatusBar.vue?vue&type=style&index=0&id=216915f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216915f3",
  null
  
)

export default component.exports